import React from "react";
import PropTypes from "prop-types";

const ThemeContext = React.createContext([
  { themename: "dark", toggeltheme: () => {} },
]);

const ThemeProvider = ({ children }) => {
  return (
    <ThemeContext.Provider value={[{ themename: "dark", toggeltheme: () => {} }]}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ThemeProvider, ThemeContext };
